import { AccountSettingsDetails } from "@/pages/me/AccountSettingsDetails.tsx";
import { AccountSettingsIntegrations } from "@/pages/me/AccountSettingsIntegrations.tsx";
import { AccountSettingsNotifications } from "@/pages/me/AccountSettingsNotifications.tsx";
import { AccountSettingsLocalisation } from "@/pages/me/AccountSettingsLocalisation.tsx";
import { AccountSettingsSecurity } from "@/pages/me/AccountSettingsSecurity.tsx";
import { AccountSettingsTheme } from "@/pages/me/AccountSettingsTheme.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";

export const accountSettingsRoutes: RouteConfig[] = [
  {
    path: "account-settings",
    children: [
      { path: "", element: <AccountSettingsDetails /> },
      { path: "localisation", element: <AccountSettingsLocalisation /> },
      { path: "security", element: <AccountSettingsSecurity /> },
      { path: "theme", element: <AccountSettingsTheme /> },
      { path: "integrations", element: <AccountSettingsIntegrations /> },
      { path: "notifications", element: <AccountSettingsNotifications /> },
    ],
  },
];
